import { cn } from '@/lib/utils';

export type EcocontLogoVariant = 'horizontal' | 'isotipo';
export type EcocontLogoTheme   = 'auto' | 'light' | 'white' | 'dark';

interface EcocontLogoProps {
  variant?:  EcocontLogoVariant;
  theme?:    EcocontLogoTheme;
  className?: string;
  alt?:      string;
}

const PATHS: Record<EcocontLogoVariant, { light: string; dark: string }> = {
  horizontal: {
    light: '/brand/ecocont-horizontal.svg',
    dark:  '/brand/ecocont-horizontal-blanco.svg',
  },
  isotipo: {
    light: '/brand/ecocont-isotipo.svg',
    dark:  '/brand/ecocont-isotipo-blanco.svg',
  },
};

/**
 * Logo oficial de ECOCONT servido como asset local (`apps/web/public/brand/`)
 * — nunca desde ecocont.pe. `theme="auto"` cambia de versión según el modo
 * claro/oscuro de Tailwind sin JS extra (`dark:hidden` / `hidden dark:block`).
 */
export function EcocontLogo({ variant = 'horizontal', theme = 'auto', className, alt = 'Ecocont Estudio' }: EcocontLogoProps) {
  const paths = PATHS[variant];

  if (theme === 'light') {
    return <img src={paths.light} alt={alt} className={cn('object-contain', className)} />;
  }
  if (theme === 'white' || theme === 'dark') {
    return <img src={paths.dark} alt={alt} className={cn('object-contain', className)} />;
  }
  return (
    <span className="inline-flex items-center">
      <img src={paths.light} alt={alt} className={cn('object-contain dark:hidden', className)} />
      <img src={paths.dark}  alt={alt} className={cn('object-contain hidden dark:block', className)} />
    </span>
  );
}
